export default {
  data: () => ({

    rawData:  [],
    
    title: null,
    schedule: null,
    progress: null,
    box: null,

    keys: null,
    filters: null,
    
    canvasForms:  null,

  }),


  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },

  methods: {
    set_ColorStyles() {
      this.gmx_ColorH4Sets()
    }
  }
  
}